// /* eslint-disable react/jsx-pascal-case */
import React, { ChangeEvent, ReactNode } from 'react'

import { Input as $Input } from 'antd'
// import "./DataEntryStyles.less";
import { InputProps as $InputProps } from 'antd/lib/input'

export interface Props {
  size?: 'large' | 'small' | 'middle'
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
  onKeyUp?: React.KeyboardEventHandler<HTMLInputElement>
  disabled?: boolean
  defaultValue?: string
  value?: string
  placeholder?: string
  prefix?: ReactNode
  suffix?: ReactNode
  className?: string
  id?: string
  name?: string
  type?: string
  min?: string | number
  max?: string | number
  ref?: any
  onClick?: (e: any) => void
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  autoFocus?: boolean
  optional?: boolean
}
export type InputProps = Props & $InputProps

const Input: React.FC<InputProps> = (props) => {
  return <$Input className="tes" {...props} />
}

export default Input
